import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "id", "timezone", "initialTime", "variant", "labelledById"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import React, { useState } from 'react';
import useUniqueId from 'hooks/useUniqueId';
import getUsersISOLocale from 'utils/i18n/getUsersISOLocale';
import getSelectableTimes from 'utils/times/getSelectableTimes';
import Flex, { Box } from 'components/Flex';
import { Select, Option } from 'components/Select';
function TimePicker(_ref) {
  var onChange = _ref.onChange,
    id = _ref.id,
    timezone = _ref.timezone,
    initialTime = _ref.initialTime,
    variant = _ref.variant,
    labelledById = _ref.labelledById,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var uniqueId = useUniqueId();
  var timezoneId = "".concat(uniqueId, "-timezone");

  // Remove the seconds (if present), as these cannot be displayed in the time picker
  var timeInHourAndMinutes = "".concat(initialTime === null || initialTime === void 0 ? void 0 : initialTime.split(':')[0], ":").concat(initialTime === null || initialTime === void 0 ? void 0 : initialTime.split(':')[1]);
  var _useState = useState(timeInHourAndMinutes),
    _useState2 = _slicedToArray(_useState, 2),
    time = _useState2[0],
    setTime = _useState2[1];
  var onChangeTime = function onChangeTime(selectedTime) {
    // Display selected time
    setTime(selectedTime);
    // Pass the local time to the parent component
    onChange(selectedTime);
  };
  return /*#__PURE__*/React.createElement(Flex, {
    wrap: true,
    align: "center"
  }, /*#__PURE__*/React.createElement(Select, _extends({
    id: id,
    menuPositionFixed: false,
    labelledById: labelledById,
    "aria-describedby": timezoneId,
    value: time,
    onChange: function onChange(newValue) {
      return onChangeTime(newValue);
    },
    variant: variant,
    mr: "xxs"
  }, otherProps), getSelectableTimes(getUsersISOLocale()).map(function (time) {
    return /*#__PURE__*/React.createElement(Option, {
      key: time.value,
      value: time.value
    }, time.label);
  })), timezone && /*#__PURE__*/React.createElement(Box, {
    id: timezoneId,
    fontSize: "s"
  }, timezone));
}
export default TimePicker;